import {
  disableMetaPixel,
  enableMetaPixel,
  initMetaPixel,
  isMetaPixelInitialized,
  parseMetaPixelConfig,
  trackMetaPageView,
} from '~/utils/metaPixel'
import { markTrackingLoaded } from '~/utils/trackingScope'

export default defineNuxtPlugin(async () => {
  const { fetchSettings, settings, loaded } = useSiteSettings()
  const { marketing, hydrate } = useCookieConsent()
  const { trackableShop } = useTrackingScope()
  const router = useRouter()

  if (!loaded.value) {
    await fetchSettings()
  }

  hydrate()

  function syncMetaPixel() {
    const slug = trackableShop()
    if (!slug) return

    const config = parseMetaPixelConfig(settings.value.meta_pixel)
    if (!config.enabled || !config.pixelIds.length) return

    if (!marketing.value) {
      disableMetaPixel()
      return
    }

    enableMetaPixel()

    if (!isMetaPixelInitialized()) {
      markTrackingLoaded(slug)
      if (initMetaPixel(config.pixelIds)) {
        trackMetaPageView()
      }
    }
  }

  watch([marketing, loaded, () => router.currentRoute.value.path], () => {
    syncMetaPixel()
  }, { immediate: true })

  router.afterEach((to) => {
    if (!marketing.value || !trackableShop(to)) return
    trackMetaPageView()
  })
})
